import getConfig from 'next/config'
import { decodeGlobalId } from '~/utils/id'

const { SEGMENT_IDENTITY_STORAGE_KEY } = getConfig().publicRuntimeConfig

export function setTrackingIdentity(user = {}, alias = true) {
  if (!global.analytics) return false
  if (!user || !user.id) return false
  if (typeof sessionStorage === 'undefined') return false
  if (sessionStorage.getItem(SEGMENT_IDENTITY_STORAGE_KEY)) return false

  const userId = decodeGlobalId(user.id)
  const {
    city,
    locationCountryCode,
    isReceivingEmailNotifications,
    isPhoneVerified,
    isEmailVerified,
    cart,
    createdAt,
  } = user

  if (alias) {
    global.analytics.alias(userId)
  }

  const identifyPayload = {
    city,
    countryCode: locationCountryCode,
    isReceivingEmailNotifications,
    isPhoneVerified,
    isEmailVerified,
    createdAt,
    hasCartItems: cart ? true : false,
    project: 'sirius',
  }

  global.analytics.identify(userId, identifyPayload)

  // In case the Hotjar tracking code tag was not yet executed
  global.hj =
    global.hj ||
    function () {
      ;(global.hj.q = global.hj.q || []).push(arguments)
    }
  // For Hotjar User Attributes
  global.hj('identify', userId, identifyPayload)

  /**
   * Call Segment’s identify() function once per session.
   * Will be called for returning logged-in users, as well
   * as newly logged-in users after clicking a magic link.
   */

  sessionStorage.setItem(SEGMENT_IDENTITY_STORAGE_KEY, 1)
}
